import React from 'react';
import {
  Modal, Form, Row, Col, Avatar, Typography, Input, Button
} from 'antd';
 
import styles from './../ViewUser/ViewUser.module.less'; 
import { useTranslation } from 'react-i18next';
import { LockOutlined } from '@ant-design/icons';
 
const { Item } = Form; 

const imagePath = 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/2048px-User-avatar.svg.png';

function UserResetPassword({
  isModalVisible,
  setIsModalVisible,
  onUserResetPassword,
  modalData,
}) {
  const { t } = useTranslation(); 

  return (
    <Modal
      centered
      title={t('common.assign_new_password')}
      visible={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={[
        <Button key="back" onClick={() => setIsModalVisible(false)} >
          <span className={styles.textInfo}>{t('common.cancel')}</span>
        </Button>,
        <Button type="primary" form="myForm" key="submit" htmlType="submit">
          {t('common.accept')}
        </Button>
      ]} 
    >
     <div>
      {/* Primera fila */}
      <Row gutter={16} align="middle">
        <Col span={4}>
          <Avatar 
          src={imagePath}
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            marginRight: 10,
            background: '#eae4e4',
          }} />
        </Col>
        <Col span={20}>
          <h2 style={{marginBottom:0}}>{modalData?.first_name} {modalData?.last_name}</h2>
          <span className={styles.spacingSubText}>ROL_NAME</span>
        </Col>
      </Row>

      {/* Segunda fila */}
      <Row gutter={16} style={{marginTop:25}}> 
        <Col span={24}>
          <Form id="myForm" layout="vertical" onFinish={onUserResetPassword}>
            <Item
              className={styles.label}
              label={t('forms.recovery_password.change_password.new_password')}
              name="new_password" 
              rules={[
                { required: true, message: t('forms.users.feedbacks.field_req') },
              ]}
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                placeholder={t('forms.recovery_password.change_password.new_password')}
              />
            </Item>

            <Item
              className={styles.label}
              label={t('forms.recovery_password.change_password.repeat_new_password')}
              name="repeat_new_password"
              rules={[
                { required: true, message: t('forms.users.feedbacks.field_req') },
              ]}
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined />}
                placeholder={t('forms.recovery_password.change_password.new_password')}
              />
            </Item>
          </Form> 
        </Col>
      </Row> 
    </div>
 
    </Modal>
  );

}

export default UserResetPassword;
